<template>
    <div class="row">
      <div class="col-12 col-md-6" v-for="(chart, index) in charts" :key="index">
        <h5>{{index + 1}}. {{ chart.title }} <span class="text-danger" v-if="!!chart.is_required"> *</span></h5>
        <div
          v-if="chart.type_id !== 4"
          class="d-flex justify-content-start"
        >
          <div class="col-md-4 p-0 mb-1">
            <label title="Tipo de gráfico" class="label-form"><span>Tipo de gráfico</span></label>
              <field-select
                :value.sync="chart.type_chart"
                :options="chartTypes"
                :change="() => updateChartOptions(chart, index)"
                :clearable="false"
                />
          </div>
        </div>
        <e-charts
          v-if="chart.type_id !== 4"
          :ref="'chart' + index"
          :options="chart.options"
          style="width: 100%; height: 400px;"
        />
        <div
          v-else
          class="scroll-comments mt-4"
        >
        <div v-if="chart.options.length > 0">
          <div
            v-for="(option, index) in chart.options"
            :key="index"
            class="custom-container-open-question">
            <span>{{ option }}</span>
          </div>
        </div>
        <div v-else class="text-center">
          <strong>Sin comentarios</strong>
        </div>
        </div>
      </div>
    </div>
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/chart/pie'
import 'echarts/lib/component/legend'

export default {
  props: ['questions'],
  components: {
    ECharts
  },
  watch: {
    questions () {
      this.setQuestions()
    }
  },
  data() {
    return {
      baseOptionsBar: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'none'
          }
        },
        series: [
          {
            label: {
              show: true,
              position: 'inside',
              rich: {
                lowValue: {
                  color: '#000',
                  fontSize: 12,
                  textBorderWidth: 0,
                  textBorderColor: 'transparent',
                  fontWeight: 'normal'
                }
              }
            },
            name: 'Recuento',
            type: 'bar',
            color: '#044389'
          }
        ]
      },
      baseOptionsPie: {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: '84%'
        },
        series: [
          {
            name: 'Opciones',
            type: 'pie',
            radius: '80%',
            selectedMode: 'single',
            label: {
              show: true,
              position: 'inside'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '18',
                fontWeight: 'bold'
              }
            }
          }
        ]
      },
      charts: [],
      chartTypes: [
        { id: 1, text: 'Gráfico de barras' },
        { id: 2, text: 'Gráfico circular' },
        { id: 3, text: 'Gráfico de barras horizontal' }
      ]
    }
  },
  mounted() {
    this.resizeChart()
    window.addEventListener('resize', this.resizeChart)
    this.setQuestions()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeChart)
  },
  methods: {
    resizeChart() {
      this.charts.forEach((_, index) => {
        const chartRef = this.$refs[`chart${index}`]
        if (chartRef) {
          chartRef[0].resize()
        }
      })
    },
    setQuestions () {
      this.charts = []
      if (!!this.questions && this.questions.length > 0) {
        this.questions.map(question => {
          const obj = {
            title: question.title,
            type_id: question.type_id,
            is_required: question.is_required,
            type_chart: this.chartTypes.find(chart => chart.id === question.type_id) || null,
            options: this.setOptionsByType(question),
            response:  question.response
          }
          this.charts.push(obj)
        })
      }
    },
    commonBarOptions (axisType, dataAxis, labelPadding, question) {
      const options = JSON.parse(JSON.stringify(this.baseOptionsBar))
      options[axisType] = {
        type: 'value',
        min: 0,
        splitNumber: 6
      }
      options[dataAxis] = {
        type: 'category',
        axisLabel: {
          formatter: value => {
            if (value.length > 6) {
              return `${value.substring(0, 6)}...`
            }
            return value
          }
        },
        data: question.response.map(item => item.option)
      }
      options.tooltip.formatter = (params) => this.setTooltipName(params)
      options.series[0].label.formatter = (params) => this.setPercentChart(params, question)
      options.series[0].label.rich.lowValue.padding = labelPadding
      options.series[0].data = question.response.map(item => item.count)
      return options
    },
    setOptionsByType(question) {
      switch (Number(question.type_id)) {
      case 1:
        return this.commonBarOptions('xAxis', 'yAxis', [0, 0, 0, 60], question)

      case 2: {
        const pieOptions = JSON.parse(JSON.stringify(this.baseOptionsPie))
        pieOptions.series[0].data = question.response.map(item => ({
          value: item.count,
          name: item.option
        }))
        pieOptions.tooltip.formatter = (params) => this.setTooltipNamePie(params)
        pieOptions.series[0].label.formatter = (params) => this.setPercentChartPie(params, question)
        pieOptions.legend.formatter = (params) => this.setLegendLabel(params)
        return pieOptions
      }

      case 3:
        return this.commonBarOptions('yAxis', 'xAxis', [40, 0, 0, 0], question)

      case 4:
        return question.response

      default:
        throw new Error(`Tipo de pregunta no admitida: ${question.type_id}`)
      }
    },
    setLegendLabel(params) {
      return params.length > 9 ? `${params.substring(0, 9)}...` : params
    },
    setTooltipNamePie (params) {
      const { name, value, percent } = params
      const formattedPercent = percent % 1 === 0 ? `${percent}%` : `${percent.toFixed(1)}%`
      return `${name} <br/> <strong>${value} (${formattedPercent})</strong>`
    },
    setPercentChartPie (params) {
      const formattedPercent = params.percent % 1 === 0 ? `${params.percent}%` : `${params.percent.toFixed(1)}%`
      return params.percent !== 0 ? formattedPercent : ''
    },
    setPercentChart (params, question) {
      const data = question.response.map(item => item.count)
      const total = data.reduce((acc, curr) => acc + curr, 0)
      const percentage = total === 0 ? 0 : Math.round((params.value / total) * 100)
      if (params.value === 0) {
        return `{lowValue|${params.value} (${percentage}%)}`
      }
      return `${params.value} (${percentage}%)`
    },
    setTooltipName (params) {
      const tar = params[0]
      return `<strong>${tar.name}</strong> <br/> ${tar.seriesName}: <strong>${tar.value}</strong>`
    },
    getChartType(typeId) {
      return this.chartTypes[typeId] || 'Tipo desconocido'
    },
    updateChartOptions(chart, index) {
      chart.type_id = chart.type_chart.id
      chart.options = this.setOptionsByType(chart)
      this.$nextTick(() => {
        const chartRef = this.$refs[`chart${index}`]
        if (chartRef) {
          chartRef[0].resize()
        }
      })
    }
  }
}
</script>

<style>
.custom-container-open-question {
  background-color: #F2F2F8;
  border-radius: 5px;
  margin: 4px 0 0;
  padding: 10px;
}
.scroll-comments {
  max-height: 400px;
  overflow-y: auto;
  padding-right: 10px;
}
.scroll-comments::-webkit-scrollbar {
  -webkit-appearance: none;
}
.scroll-comments::-webkit-scrollbar:vertical {
  width: 11px;
}
.scroll-comments::-webkit-scrollbar:horizontal {
  height: 11px;
}
.scroll-comments::-webkit-scrollbar-thumb {
  border-radius: 8px;
  border: 2px solid white;
  background-color: rgba(0, 0, 0, .5);
}
.scroll-comments::-webkit-scrollbar-track {
  background-color: #fff;
  border-radius: 8px;
}
</style>